<template>
  <div style="position: relative" v-if="carousel_items.length > 0">
    <Carousel
      ref="carousel"
      :paginationEnabled="false"
      :perPage="1"
      :autoplay="true"
      :loop="true"
      :autoplayTimeout="10000"
      :mouseDrag="false"
    >
      <Slide :key="'carousel_' + index" v-for="(item, index) in carousel_items">
        <div class="product-item">
          <div class="product-item-content">
            <div
              class="mb-3"
              :class="{ 'cursor-pointer': item.link }"
              @click="linkTo(item.link)"
            >
              <img
                :src="'/storage/ad-images/' + item.image + '/1000.jpg'"
                class="product-image aspect-ratio mx-auto"
                :class="{ 'w-full': item.fit }"
              />
            </div>
          </div>
        </div>
      </Slide>
    </Carousel>
    <div
      v-if="pageCount > 1"
      class="prev"
      @click="previousPage"
      @mouseenter="$refs.carousel.pauseAutoplay()"
      @mouseleave="$refs.carousel.restartAutoplay()"
    >
      <i class="pi pi-angle-left w-6 h-6 py-1 ml-2" style="font-size: 2rem"></i>
    </div>
    <div
      v-if="pageCount > 1"
      class="next"
      @click="nextPage"
      @mouseenter="$refs.carousel.pauseAutoplay()"
      @mouseleave="$refs.carousel.restartAutoplay()"
    >
      <i
        class="pi pi-angle-right w-6 h-6 py-1 mr-2"
        style="font-size: 2rem"
      ></i>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  props: {
    dataSet: {
      type: Array,
      default: [],
    },
    group: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      carousel_items: [],
      pageCount: 1,
    };
  },
  methods: {
    linkTo(href) {
      if (href) {
        this.$inertia.visit(href);
      }
    },
    nextPage() {
      this.$refs.carousel.advancePage("forward");
      this.currentPage = this.$refs.carousel.currentPage;
    },
    previousPage() {
      this.$refs.carousel.advancePage("backward");
      this.currentPage = this.$refs.carousel.currentPage;
    },
  },
  mounted() {
    this.carousel_items = this.dataSet.filter((ad) => {
      return ad.group == this.group;
    });
    this.pageCount = this.carousel_items.length;
  },
};
</script>

<style lang="postcss">
.prev {
  @apply cursor-pointer absolute flex flex-col justify-center items-center left-0 top-0 bottom-[12px] w-16 opacity-0;
}

.next {
  @apply cursor-pointer absolute flex flex-col justify-center items-center right-0 top-0 bottom-[12px] w-16 opacity-0;
}

.prev:hover {
  @apply bg-gradient-to-r from-fh-blue opacity-50;
}

.next:hover {
  @apply bg-gradient-to-l from-fh-blue opacity-50;
}
</style>